import * as React from 'react';
import Params from '../../options/Params';

// assets
import playGuide1 from "../../../images/PlayGuide1.svg";
import playGuide2 from "../../../images/PlayGuide2.svg";
import playGuide3 from "../../../images/PlayGuide3.svg";
import playGuide4 from "../../../images/PlayGuide4.svg";
import './playGuide.css';

interface PlayGuideState {
	open: boolean;
}

export class PlayGuide extends React.Component<{}, PlayGuideState> {
	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			open: !Params.shared
		};


		document.body.addEventListener("open-guide", () => this.setOpen(true));
	}

	public render() {
		const hiddenClass = this.state.open ? "" : "hidden";

		return <div className={`guide ${hiddenClass}`}>
			<div className="guide-pane guide-pane-1">
				<div className="guide-title">DRAG FROM PALETTE TO ADD ORBITAL <br /> DROP ON CENTRAL ATOM</div>
				<img src={playGuide1} />
			</div>
			<div className="guide-pane guide-pane-2">
				<div className="guide-title">REPEAT TO ADD ANOTHER ORBITAL</div>
				<img src={playGuide2} />
			</div>
			<div className="guide-pane guide-pane-3">
				<div className="guide-title">CLICK & DRAG THE EMPTY SPACE TO ROTATE THE ENTIRE MOLECULE</div>
				<img src={playGuide3} />
			</div>
			<div className="guide-pane guide-pane-4">
				<div className="guide-title">CLICK & DRAG OUT FROM THE ATOM CENTER TO ROTATE THE ORBITALS</div>
				<img src={playGuide4} />
			</div>
			<div className="guide-line-horizontal-1"></div>
			<div className="guide-line-horizontal-2"></div>
			<div className="guide-line-vertical-1"></div>
			<div className="guide-line-vertical-2"></div>
			<button className='guide-start-button' onClick={() => this.setOpen(false)}>
				START
			</button>
		</div>
	}

	setOpen(open: boolean) {
		this.setState({ open: open });
	}
}